import {keepPreviousData, useQuery} from "@tanstack/react-query";
import HeaderServices from "@/http/api/header/HeaderServices";

export default class HeaderQueryHooks extends HeaderServices {
    useHeaderCategory = () => {
        return useQuery({
            queryFn: () => this.getHeaderCategoryList(),
            queryKey: ["header"],
            staleTime: 1000 * 60 * 60,
            gcTime: 1000 * 60 * 60,
            retry : 1 ,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            refetchOnReconnect: false,
            placeholderData: keepPreviousData,
        });
    };
}